import { useState } from "react";
import axios from "axios";
import "../App.css";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function LoginPage() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [remember, setRemember] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      const response = await axios.post(`${BACKEND_URL}/login`, {
        username,
        password,
      });
      const token = response.data.access_token;
      if (remember) {
        localStorage.setItem("userId", token);
      } else {
        sessionStorage.setItem("userId", token);
      }
      window.location.href = "/";
    } catch (err) {
      setError("Invalid username or password");
    }
  };

  return (
    <div className="login-container center login-center">
      <form className="login-form" onSubmit={handleSubmit}>
        <h2 className="login-title">Login</h2>
        <label>
          Username
          <input
            type="text"
            value={username}
            onChange={e => setUsername(e.target.value)}
            required
            className="login-input"
          />
        </label>
        <label>
          Password
          <input
            type="password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            required
            className="login-input"
          />
        </label>
        <label className="login-checkbox-label">
          <input
            type="checkbox"
            checked={remember}
            onChange={e => setRemember(e.target.checked)}
            className="login-checkbox"
          />
          Remember me
        </label>
        <button type="submit" className="login-button">Login</button>
        {error && <div className="login-error">{error}</div>}
        <a href="/register" className="login-link">Register</a>
      </form>
    </div>
  );
}